import { render } from "./InnerContentSection.vue?vue&type=template&id=50b2284c"
import script from "./InnerContentSection.vue?vue&type=script&lang=js"
export * from "./InnerContentSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__